import type { RouteName } from "@malfak/contracts";
import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "./errors";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      // Client errors won't fix themselves; network blips and 5xx get two more tries.
      retry: (count, err) => (isApiError(err) && err.status >= 400 && err.status < 500 ? false : count < 2),
    },
    mutations: { retry: false },
  },
});

/** Invalidate every cached page/filter of the given routes. */
export function invalidate(...names: RouteName[]) {
  return Promise.all(names.map((n) => queryClient.invalidateQueries({ queryKey: [n] })));
}
